// extracted by mini-css-extract-plugin
module.exports = {"ImportListProductGeneralTab":"ImportListProductGeneralTab_ImportListProductGeneralTab__17bgb","Chip":"ImportListProductGeneralTab_Chip__3anjF"};